<template>
  <div class="page">
    <div class="page-content">
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
              <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                      <f7-icon f7="person_round"></f7-icon>
                      {{ $t('businessMembers.add_member') }}
                  </h4>
              </div>

              <form>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label"><span class="color-red">* </span>{{ $t('loginPage.lgn') }}</label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" placeholder="Login" v-model="login"></input>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">{{ $t('rights.rights_profile') }}</label>
                  <div class="col-7 col-sm-10">
                    <select class="form-control" id="sel4" v-model="selectedConfig" readonly>
                      <option :value="{}">{{ $t('rights.select_profile') }}</option>
                      <option v-for="config in configList"
                        :key="config.idProfile"
                        :value="config">
                        {{ config.libelleProfile }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="row justify-content-start">
          <div class="col-6 offset-md-5 col-md-3 height-button">
            <button round
              class="button-action firstButtonMarginTop milkyBlockBlack"
              @click="goBack">
              <i class="icon fa fa-ban"></i>
              <span>{{ $t('common.cncl') }}</span>
            </button>
          </div>
          <div class="col-6 col-md-3 height-button">
            <button round
              class="button-action firstButtonMarginTop milkyBlockBlack"
              @click="addAccountMember">
              <f7-icon f7="add"></f7-icon>
              <span>{{ $t('common.add_label') }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage, pageBack} from '@/helpers/routing'

export default {
  name: 'AddAccountMember',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      labelNewAccountMember: this.$i18n.t('businessMembers.new_member'),
      login: '',
      status: '',
      configList: [],
      selectedConfig: {},
      usedConfig: {}
    }
  },
  created () {
    let that = this
    that.$engine.rights.getAllProfiles().then(resp => {
      if (resp.profiles) {
        that.configList = resp.profiles
        let usedConfig = that.configList.find(config => {
          if (config.users) {
            return config.users.find(user => {
              return user === that.login
            })
          }
        })
        if (usedConfig) {
          that.previousProfilId = usedConfig.idProfile
          that.selectedConfig = usedConfig
        }
      }
    })
  },
  methods: {
    addAccountMember () {
      this.$f7.showPreloader('')
      const that = this
      if (that.login !== '') {
        that.$engine.accounts.addUserToAccount(that.login, that.selectedConfig.idProfile)
          .then(response => {
            if (response.status === 200) {
              that.$f7.hidePreloader()
              this.$f7.closeModal()
              that.$f7.alert('User correctly added', 'Success')
              this.$bus.$emit('refresh-cache-account-members')
              loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
            }
          })
          .catch(err => {
            errorMessageAlert(err, that)
          })
      } else {
        this.$f7.hidePreloader()
        this.$f7.alert('', 'Data empty')
      }
    },
    goBack () {
      pageBack(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMAddAccountMember.vue?85d6e6e8